<template>
  <div id="ball-game" class="game">
    <router-link to="/" tag="div" class="close">×</router-link>
    <h1>Magic 8-ball</h1>
    <form class="game-wrapper layout-1" @submit="shake">
      <div class="layout-content">
        <div id="ball" :class="{'shaking': shaking}">
          <div id="ball-text" :class="{'deep': deep}">{{ texts[text_n] }}</div>
        </div>
      </div>
      <div class="layout-navigation"><button class="action-button">Shake the ball</button></div>
    </form>
  </div>
</template>

<script>

import Random from './../utils/random'

export default {
  data: function () {
    return {
      'texts': [
        'It is certain',
        'It is decidedly so',
        'Without a doubt',
        'Yes — definitely',
        'You may rely on it',
        'As I see it, yes',
        'Most likely',
        'Outlook good',
        'Signs point to yes',
        'Yes',
        'Reply hazy, try again',
        'Ask again later',
        'Better not tell you now',
        'Cannot predict now',
        'Concentrate and ask again',
        'Don\'t count on it',
        'My reply is no',
        'My sources say no',
        'Outlook not so good',
        'Very doubtful',
      ],
      'shaking': false,
      'deep': false,
      'text_n': null
    }
  },
  methods: {
    shake: function (e) {
      e.preventDefault();
      const time = this.$data.hidden ? 1 : 500;
      this.$data.shaking = true;
      setTimeout(() => {
        this.$data.text_n = Random.getNumber(0, this.$data.texts.length - 1);
        this.$data.deep = false;
      }, time);
      setTimeout(() => {
        this.$data.shaking = false;
      }, time * 1.6);
    }
  }
}
</script>

<style src="./../assets/css/game.css" scoped></style>
<style scoped>

  div#ball-game {
    background-image: url('../assets/img/game/8ball/bg.jpg');
  }
  div#ball {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -210px;
    margin-left: -210px;
    z-index: 1;
    width: 420px;
    height: 420px;
    background: url('../assets/img/game/8ball/ball-back.png') 50% 50% no-repeat;
    background-size: contain;
  }
  div#ball:after {
    content: '';
    position: absolute;
    z-index: 3;
    width: 420px;
    height: 420px;
    background: url('../assets/img/game/8ball/ball-front.png') 50% 50% no-repeat;
    background-size: contain;
  }
  div#ball div#ball-text {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;
    margin-left: -88px;
    margin-top: -60px;
    width: 177px;
    height: 153px;
    background: url('../assets/img/game/8ball/ball-triangle.png') 50% 50% no-repeat;
    background-size: contain;
    box-sizing: border-box;
    padding: 10px 40px;
    text-align: center;
    color: #ffffff;
    transition: opacity 0.5s linear;
    opacity: 1;
  }
  div#ball.shaking {
    animation: shake 0.8s;
    animation-iteration-count: 1;
  }
  div#ball div#ball-text.deep,
  div#ball.shaking div#ball-text {
    opacity: 0;
  }

  @media all and (max-width: 919px) {

    div#ball {
      margin-top: -150px;
      margin-left: -150px;
      width: 300px;
      height: 300px;
    }
    div#ball:after {
      width: 300px;
      height: 300px;
    }
    div#ball div#ball-text {
      margin-top: -50px;
    }

  }

  @keyframes shake {
    0% { left: 50%; }
    25% { left: 35%; }
    75% { left: 65%; }
    100% { left: 50%; }
  }


</style>
